import React, { useState } from 'react';
import { ServicesGrid } from '../../components/services-grid/ServicesGrid';
import { Button, Flexbox, Icon, Navbar, Typography } from '@hiiretail/synergy-ui';
import styled from 'styled-components';
import { UserMenu } from '../../components/UserMenu/UserMenu';
import { TryNewConsoleButton } from '../../components/TryNewConsoleButton/TryNewConsoleButton';
import { FeatureFlagsWrapper } from 'providers/FeatureFlags/FeatureFlagsWrapper';
import { useAuthProvider } from 'auth/useAuthProvider';

const StyledLogoBtn = styled(Navbar.NavItem)`
  cursor: default;
  pointer-events: none;
`;

export const Home: React.FC = () => {
  const { currentUser, firebaseApp } = useAuthProvider();
  const [displayedName, setDisplayedName] = useState('');

  currentUser?.getIdTokenResult().then((idTokenResult) => {
    setDisplayedName(idTokenResult.claims.name ?? idTokenResult.claims.email);
  });

  return (
    <FeatureFlagsWrapper>
      <div id="home">
        <Navbar.Container>
          <Navbar.Nav>
            <StyledLogoBtn to="/" logo>
              <Icon.ExtendaLogo size="lg" color={() => 'white'} />
            </StyledLogoBtn>
            <Typography weight="bold">Hii Console</Typography>
          </Navbar.Nav>
          <Flexbox container alignItems="center" gutter={2}>
            <TryNewConsoleButton />
            <UserMenu title={displayedName} firebaseApp={firebaseApp}>
              <Flexbox item>
                <Button
                  fullWidth
                  onClick={() => (globalThis.location.href = `${globalThis.location}iam/my-tenant`)}
                  variant="secondary">
                  My tenant
                </Button>
              </Flexbox>
            </UserMenu>
          </Flexbox>
        </Navbar.Container>
        <ServicesGrid />
      </div>
    </FeatureFlagsWrapper>
  );
};
